import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as getTime from '~/skills/getTime';
import * as getStatus from '~/skills/getStatus';
import Actions from '~/Actions';
import Actions_Wind from '~/Actions_Wind';
import PageTitle from '~/components/PageTitle';
import CircleCheckBox from '~/components/CheckBox/CircleCheckBox';
import SearchBar from '~/components/SearchBar';
import AddRes from '~/components/Dialog/AddRes';
import EditRes from '~/components/Dialog/EditRes';
import BoatAdminTree from '~/components/BoatAdminTree';
import { EAA_Item, EAA_ItemContainer, EAA_Input, EAA_Select, EAA_Row, EAA_TitleText, EAA_Date, EAA_Memo, EAA_Upload, EAA_ErrorText, EAA_Status, EAA_UpdateTime, EAA_BottomBtn } from '~/components/EditAndAddItem';

import ConsultMeet from './ConsultMeet';
import ReviewMeet from './ReviewMeet';

import Sub1 from './Sub1';
import Sub2 from './Sub2';

const modeInfo = {
  add: {
    title: '外籍船舶新增',
  },
  edit: {
    title: '外籍船舶編輯',
  },
  view: {
    title: '外籍船舶檢視',
  },
};

class AddAndEdit extends Component {
  state={ data: {}, old_data: {}, mode: '', canSend: true, errorAry: [] }
  componentDidMount () {
    this.openDate = new Date();
    const { id, getForeignBoatIdDetail, getBaseData, mode = '', setPageText } = this.props;
    setPageText(modeInfo[mode].title);
    if (mode !== 'add')getForeignBoatIdDetail(id);
    getBaseData();
  }

  componentDidUpdate (preProps) {
    const { ForeignBoatIdDetail: preForeignBoatIdDetail = {} } = preProps;
    const { ForeignBoatIdDetail = {}, mode } = this.props;
    if (Object.keys(preForeignBoatIdDetail).length === 0 && Object.keys(ForeignBoatIdDetail).length > 0 && (mode !== 'add')) {
      this.setState({ data: ForeignBoatIdDetail, old_data: ForeignBoatIdDetail });
    }
  }

  componentWillUnmount () {
    const { clearKey } = this.props;
    clearKey('ForeignBoatIdDetail');
    clearKey('PageText');
  }

  _onClose=() => {
    this.props._onClose();
  }

  changeData=({ label = '', data = '' }, func = () => {}) => {
    const { data: body } = this.state;
    const newBody = {
      ...body,
      [label]: data,
    };
    this.setState({ data: newBody }, func);
  }

  getSendBody=() => {
    const { data = {} } = this.state;
    const returnInputValue = t => typeof (t) !== ('undefined') && typeof (t) !== ('object') ? t : '';
    const overTime = (returnInputValue(data.apply_sail_date) !== '') && (this.openDate > getTime.returnDate(data.apply_sail_date));
    const is_pass = overTime && (data.is_pass === '2');
    const is_review = is_pass && (data.is_review === '2');
    const is_taiwan = data.is_taiwan === '1';
    const body = {
      ship_name: data.ship_name || '', // 申請船舶名稱
      imo: data.imo || '', // imo
      shipowner: data.shipowner || '', // 船東
      citizenship: data.citizenship || '', // 國籍
      made_place: data.made_place || '', // 製造地
      is_china_refit: data.is_china_refit || '', // 是否先到中國進行改裝
      is_made_china: data.is_made_china || '', // 原始製造地是否為中國
      ship_stage: data.ship_stage || '', // 階段
      exec_job: data.exec_job || [], // 執行作業
      ship_func: data.ship_func || '', // 船舶功能
      apply_sail_date: data.apply_sail_date || '', // 擬申請船期 - 規劃送件日期
      meet_date: overTime ? (data.meet_date || '') : '', // 諮詢會議 - 會議日期
      is_pass: overTime ? (data.is_pass || '') : '', // 諮詢會議 - 通過與否
      meet_upload_files: overTime ? (data.meet_upload_files || []) : [],
      review_date: is_pass ? (data.review_date || '') : '', // 審查會議 - 會議日期
      review_upload_files: is_pass ? (data.review_upload_files || []) : [],
      is_review: is_pass ? (data.is_review || '') : '', // 審查會議 - 通過與否
      agree_letter_date: data.agree_letter_date || '', // 能源署同意函 - 公文日期
      agree_upload_files: data.agree_upload_files || [],
      is_taiwan: data.is_taiwan || '', // 確認是否抵台
      actural_taiwan_date: is_taiwan ? (data.actural_taiwan_date || '') : '', // 確認是否抵台 - 實際抵台日期
      port_letter_date: is_taiwan ? (data.port_letter_date || '') : '', // 航港局同意函 - 公文日期
      port_letter_upload_files: is_taiwan ? (data.port_letter_upload_files || []) : [],
      note: data.note || '',
      sub1: data.sub1 || [],
      sub2: data.sub2 || [],
      sub3: data.sub3 || [],

      windcontract_id: Actions_Wind.wind_id(),
    };
    return body;
  }

  add=(status = {}) => {
    this.setState({ canSend: false });
    const body = { ...this.getSendBody(), ...status };
    this.props.postAddNewForeignBoat(body);
  }

  goToCheck=() => this.setState({ mode: 'check' }, () => this.filterError())
  goToEdit=() => this.setState({ mode: '', errorAry: [] });
  edit=(status = {}) => {
    const { id, putForeignBoatIdDetail } = this.props;
    this.setState({ canSend: false });
    const body = { ...this.getSendBody(), ...status };
    putForeignBoatIdDetail(id, body);
  }

  filterError=() => {
    const { data = {} } = this.state;
    const returnInputValue = t => typeof (t) !== ('undefined') && typeof (t) !== ('object') ? t : '';
    const overTime = (returnInputValue(data.apply_sail_date) !== '') && (this.openDate > getTime.returnDate(data.apply_sail_date));
    const is_pass = overTime && (data.is_pass === '2');
    const is_review = is_pass && (data.is_review === '2');
    const is_taiwan = data.is_taiwan === '1';
    const errorAry = [
      returnInputValue(data.ship_name) === '', // 0 申請船舶名稱
      returnInputValue(data.imo) === '', // 1 imo
      returnInputValue(data.shipowner) === '', // 2 船東
      returnInputValue(data.citizenship) === '', // 3 國籍
      returnInputValue(data.made_place) === '', // 4 製造地
      returnInputValue(data.is_china_refit) === '', // 5 是否先到中國進行改裝
      returnInputValue(data.is_made_china) === '', // 6 原始製造地是否為中國
      returnInputValue(data.ship_stage) === '', // 7 階段
      returnInputValue(data.ship_func) === '', // 8 船舶功能
      returnInputValue(data.apply_sail_date) === '', // 9 擬申請船期 - 規劃送件日期
      overTime && returnInputValue(data.meet_date) === '', // 10 諮詢會議 - 會議日期
      overTime && returnInputValue(data.is_pass) === '', // 11 諮詢會議 - 通過與否
      overTime && (data.meet_upload_files || []).length === 0, // 12 諮詢會議 - 上傳會議紀要函文
      is_pass && (returnInputValue(data.review_date) === ''), // 13 審查會議 - 會議日期
      is_pass && (data.review_upload_files || []).length === 0, // 14 審查會議 - 上傳會議紀要函文
      is_pass && (returnInputValue(data.is_review) === ''), // 15 審查會議 - 通過與否
      is_review && (returnInputValue(data.agree_letter_date) === ''), // 16 能源署同意函 - 公文日期
      is_review && (data.agree_upload_files || []).length === 0, // 17 能源署同意函 - 上傳公文
      is_taiwan && (returnInputValue(data.actural_taiwan_date) === ''), // 18 確認是否抵台 - 實際抵台日期
      is_taiwan && (returnInputValue(data.port_letter_date) === ''), // 19 航港局同意函 - 公文日期
      is_taiwan && (data.port_letter_upload_files || []).length === 0, // 20 航港局同意函 - 上傳公文
    ];
    this.setState({ errorAry });
    return errorAry.indexOf(true) !== -1;
  }

  render () {
    const { mode = '', BoatStageList = [], ForeignBoatNationList } = this.props;
    const { data = {}, old_data = {}, canSend, errorAry } = this.state;
    const isCheck = this.state.mode === 'check';
    const isEdit = mode === 'edit';
    const disabled = mode === 'view' || isCheck || (!getStatus.canEdit(data));
    const checkChange = label => isCheck ? (data[label] || '') !== (old_data[label] || '') : false;
    const returnInputValue = t => typeof (t) !== ('undefined') && typeof (t) !== ('object') ? t : '';
    const returnForceOpen = ({ least = 0, most = 0 }) => {
      for (let i = 0; i < errorAry.length; i++) {
        if (i >= least && i <= most && errorAry[i]) return true;
      }
      return false;
    };
    const allRight = errorAry.indexOf(true) === -1;
    const titleWidth = 170;
    const errorLeft = 20 + titleWidth;

    const overTime = (returnInputValue(data.apply_sail_date) !== '') && (this.openDate > getTime.returnDate(data.apply_sail_date));
    const is_pass = overTime && (data.is_pass === '2');
    const is_review = is_pass && (data.is_review === '2');
    const is_taiwan = data.is_taiwan === '1';

    return (
      <div style={{
        position: 'absolute',
        left: 13,
        right: 0,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        overflow: 'auto',
      }}
      >
        <PageTitle text={modeInfo[mode].title} />

        <SearchBar style={{ marginTop: 8 }} defaultOpen forceOpen={returnForceOpen({ least: 0, most: 1 })}>
          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='申請船舶名稱' bol={true} haveChange={checkChange('ship_name')} />
                <EAA_Input displayBorder disabled={disabled} hint='詳答' value={returnInputValue(data.ship_name)} onChange={data => { this.changeData({ label: 'ship_name', data }); }} />
              </EAA_ItemContainer>
              {errorAry[0] && <EAA_ErrorText marginLeft={errorLeft} text='請輸入' />}
            </EAA_Item>
          </EAA_Row>

          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='IMO' bol={true} haveChange={checkChange('imo')} />
                <EAA_Input displayBorder disabled={disabled} hint='詳答' value={returnInputValue(data.imo)} onChange={data => { this.changeData({ label: 'imo', data }); }} />
              </EAA_ItemContainer>
              {errorAry[1] && <EAA_ErrorText marginLeft={errorLeft} text='請輸入' />}
            </EAA_Item>
          </EAA_Row>

          <Sub1 data={data} disabled={disabled} titleWidth={titleWidth} checkChange={checkChange} changeData={this.changeData} />

        </SearchBar>

        <SearchBar style={{ marginTop: 8 }} forceOpen={returnForceOpen({ least: 2, most: 6 })}>
          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='船東' bol={true} haveChange={checkChange('shipowner')} />
                <EAA_Input displayBorder disabled={disabled} hint='英文全名' value={returnInputValue(data.shipowner)} onChange={data => { this.changeData({ label: 'shipowner', data }); }} />
              </EAA_ItemContainer>
              {errorAry[2] && <EAA_ErrorText marginLeft={errorLeft} text='請輸入' />}
            </EAA_Item>
          </EAA_Row>

          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='國籍' bol={true} haveChange={checkChange('citizenship')} />
                <EAA_Select displayBorder disabled={disabled} list={ForeignBoatNationList} value={returnInputValue(data.citizenship)} onChange={data => { this.changeData({ label: 'citizenship', data }); }} />
              </EAA_ItemContainer>
              {errorAry[3] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇' />}
            </EAA_Item>
          </EAA_Row>

          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='製造地' bol={true} haveChange={checkChange('made_place')} />
                <EAA_Select displayBorder disabled={disabled} list={ForeignBoatNationList} value={returnInputValue(data.made_place)} onChange={data => { this.changeData({ label: 'made_place', data }); }} />
              </EAA_ItemContainer>
              {errorAry[4] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇' />}
            </EAA_Item>
          </EAA_Row>

          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='是否先到中國進行改裝' bol={true} haveChange={checkChange('is_china_refit')} />
                <CircleCheckBox disabled={disabled} value={data.is_china_refit === '1'} onClick={() => this.changeData({ label: 'is_china_refit', data: '1' })} />
                <div style={{ marginRight: 8 }}>是</div>
                <CircleCheckBox disabled={disabled} value={data.is_china_refit === '0'} onClick={() => this.changeData({ label: 'is_china_refit', data: '0' })} />
                <div>否</div>
              </EAA_ItemContainer>
              {errorAry[5] && <EAA_ErrorText marginLeft={errorLeft} text='請勾選' />}
            </EAA_Item>
          </EAA_Row>

          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='原始製造地是否為中國' bol={true} haveChange={checkChange('is_made_china')} />
                <CircleCheckBox disabled={disabled} value={data.is_made_china === '1'} onClick={() => this.changeData({ label: 'is_made_china', data: '1' })} />
                <div style={{ marginRight: 8 }}>是</div>
                <CircleCheckBox disabled={disabled} value={data.is_made_china === '0'} onClick={() => this.changeData({ label: 'is_made_china', data: '0' })} />
                <div>否</div>
              </EAA_ItemContainer>
              {errorAry[6] && <EAA_ErrorText marginLeft={errorLeft} text='請勾選' />}
            </EAA_Item>
          </EAA_Row>
        </SearchBar>

        <SearchBar style={{ marginTop: 8 }} forceOpen={returnForceOpen({ least: 7, most: 8 })}>
          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='階段' bol={true} haveChange={checkChange('ship_stage')} />
                <EAA_Select displayBorder disabled={disabled} list={BoatStageList} value={returnInputValue(data.ship_stage)} onChange={data => { this.changeData({ label: 'ship_stage', data }); }} />
              </EAA_ItemContainer>
              {errorAry[7] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇' />}
            </EAA_Item>
          </EAA_Row>

          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='執行作業' bol={true} haveChange={isCheck && (JSON.stringify(data.exec_job || []) !== JSON.stringify(old_data.exec_job || []))} />
                <BoatAdminTree value={data.exec_job || []} onChange={data => this.changeData({ label: 'exec_job', data }) } {...{ disabled }} />
              </EAA_ItemContainer>
              {/* {errorAry[0] && <EAA_ErrorText marginLeft={errorLeft} text='帳號需為 1 ~ 100 英數字。' />} */}
            </EAA_Item>
          </EAA_Row>

          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='船舶功能' bol={true} haveChange={checkChange('ship_func')} />
                <EAA_Input displayBorder disabled={disabled} hint='詳答' value={returnInputValue(data.ship_func)} onChange={data => { this.changeData({ label: 'ship_func', data }); }} />
              </EAA_ItemContainer>
              {errorAry[8] && <EAA_ErrorText marginLeft={errorLeft} text='請輸入' />}
            </EAA_Item>
          </EAA_Row>
        </SearchBar>

        <SearchBar style={{ marginTop: 8 }} forceOpen={returnForceOpen({ least: 9, most: 20 })}>

          <Sub2 data={data} disabled={disabled} titleWidth={titleWidth} checkChange={checkChange} changeData={this.changeData} errorAry={errorAry} errorLeft={errorLeft} />

          {overTime && (
            <ConsultMeet
              titleWidth={titleWidth}
              disabled={disabled}
              checkChange={checkChange}
              data={data}
              changeData={this.changeData}
              errorAry={errorAry}
              errorLeft={errorLeft}
            />
          )}
          {is_pass && (
            <ReviewMeet
              titleWidth={titleWidth}
              disabled={disabled}
              checkChange={checkChange}
              data={data}
              changeData={this.changeData}
              errorAry={errorAry}
              errorLeft={errorLeft}
            />
          )}

          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='' />
                <div style={{ flex: 1, fontSize: 16, fontWeight: 400, color: 'rgba(0, 0, 0, 0.54)', marginRight: 12 }}>公文日期</div>
                <div style={{ flex: 1, fontSize: 16, fontWeight: 400, color: 'rgba(0, 0, 0, 0.54)', marginRight: 12 }}>上傳公文</div>
                <div style={{ flex: 1, fontSize: 16, fontWeight: 400, color: 'rgba(0, 0, 0, 0.54)', marginRight: 12 + 150 }} />
              </EAA_ItemContainer>
            </EAA_Item>
          </EAA_Row>
          <EAA_Row style={{ marginTop: 0 }}>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='能源署同意函' bol={is_review} haveChange={checkChange('agree_letter_date')} />
                <EAA_Date displayBorder disabled={disabled} marginRight={8} value={getTime.returnDate(data.agree_letter_date)} onChange={data => this.changeData({ label: 'agree_letter_date', data: getTime.getType3Time(data) })} />
                <EAA_Upload displayBorder disabled={disabled} marginRight={8} value={data.agree_upload_files || []} onChange={data => this.changeData({ label: 'agree_upload_files', data })} />
                <div style={{ flex: 1, marginRight: 8 }} />
                <div style={{ width: 150 }} />
              </EAA_ItemContainer>
              {errorAry[16] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇『公文日期』' />}
              {errorAry[17] && <EAA_ErrorText marginLeft={errorLeft} text='請上傳『公文』' />}
            </EAA_Item>
          </EAA_Row>
          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='' />
                <div style={{ flex: 1, fontSize: 16, fontWeight: 400, color: 'rgba(0, 0, 0, 0.54)', marginRight: 12 }}>抵台與否</div>
                <div style={{ flex: 1, fontSize: 16, fontWeight: 400, color: 'rgba(0, 0, 0, 0.54)', marginRight: 12 }}>{is_taiwan ? '實際抵台日期' : ''}</div>
                <div style={{ flex: 1, fontSize: 16, fontWeight: 400, color: 'rgba(0, 0, 0, 0.54)', marginRight: 12 + 150 }} />
              </EAA_ItemContainer>
            </EAA_Item>
          </EAA_Row>
          <EAA_Row style={{ marginTop: 0 }}>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='確認是否抵台' bol={is_taiwan} haveChange={checkChange('is_taiwan') || checkChange('actural_taiwan_date')} />
                <div style={{ flex: 1, marginRight: 8, display: 'flex' }}>
                  <CircleCheckBox disabled={disabled} value={data.is_taiwan === '1'} onClick={() => this.changeData({ label: 'is_taiwan', data: '1' })} />
                  <div style={{ marginRight: 8 }}>是</div>
                  <CircleCheckBox disabled={disabled} value={data.is_taiwan === '2'} onClick={() => this.changeData({ label: 'is_taiwan', data: '2' })} />
                  <div>否</div>
                </div>
                {is_taiwan && <EAA_Date displayBorder disabled={disabled} marginRight={8} value={getTime.returnDate(data.actural_taiwan_date)} onChange={data => this.changeData({ label: 'actural_taiwan_date', data: getTime.getType3Time(data) })} />}
                <div style={{ flex: 1, marginRight: 8 }} />
                <div style={{ width: 150 }} />
              </EAA_ItemContainer>
              {errorAry[18] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇『實際抵台日期』' />}
            </EAA_Item>
          </EAA_Row>

          {is_taiwan && (
            <EAA_Row>
              <EAA_Item>
                <EAA_ItemContainer>
                  <EAA_TitleText width={titleWidth} text='' />
                  <div style={{ flex: 1, fontSize: 16, fontWeight: 400, color: 'rgba(0, 0, 0, 0.54)', marginRight: 12 }}>公文日期</div>
                  <div style={{ flex: 1, fontSize: 16, fontWeight: 400, color: 'rgba(0, 0, 0, 0.54)', marginRight: 12 }}>上傳公文</div>
                  <div style={{ flex: 1, fontSize: 16, fontWeight: 400, color: 'rgba(0, 0, 0, 0.54)', marginRight: 12 + 150 }} />
                </EAA_ItemContainer>
              </EAA_Item>
            </EAA_Row>
          )}
          {is_taiwan && (
            <EAA_Row style={{ marginTop: 0 }}>
              <EAA_Item>
                <EAA_ItemContainer>
                  <EAA_TitleText width={titleWidth} text='航港局同意函' bol={true} haveChange={checkChange('port_letter_date')} />
                  <EAA_Date displayBorder disabled={disabled} marginRight={8} value={getTime.returnDate(data.port_letter_date)} onChange={data => this.changeData({ label: 'port_letter_date', data: getTime.getType3Time(data) })} />
                  <EAA_Upload displayBorder disabled={disabled} marginRight={8} value={data.port_letter_upload_files || []} onChange={data => this.changeData({ label: 'port_letter_upload_files', data })} />
                  <div style={{ flex: 1, marginRight: 8 }} />
                  <div style={{ width: 150 }} />
                </EAA_ItemContainer>
                {errorAry[19] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇『公文日期』' />}
                {errorAry[20] && <EAA_ErrorText marginLeft={errorLeft} text='請上傳『公文』' />}
              </EAA_Item>
            </EAA_Row>
          )}

        </SearchBar>

        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText width={titleWidth} text='備註' bol={true} haveChange={checkChange('note')} />
              <EAA_Memo displayBorder disabled={disabled} value={returnInputValue(data.note)} onChange={data => { this.changeData({ label: 'note', data }); }} />
            </EAA_ItemContainer>
            {/* {errorAry[0] && <EAA_ErrorText text='帳號需為 1 ~ 100 英數字。' />} */}
          </EAA_Item>
        </EAA_Row>

        <div style={{ height: 16 }} />

        <EAA_Status data={data} />
        <EAA_UpdateTime data={data} />

        <EAA_BottomBtn
          {...{
            data,
            mode,
            isCheck,
            allRight,
            canSend,
            onClose: this._onClose,
            goToCheck: this.goToCheck,
            goToEdit: this.goToEdit,
            add: this.add,
            edit: this.edit,
          }}
        />
        <AddRes sucFunc={this._onClose} failFunc={() => this.setState({ canSend: true })} resKey='PostAddNewForeignBoat' />
        <EditRes sucFunc={this._onClose} failFunc={() => this.setState({ canSend: true })} resKey='PutForeignBoatIdDetail' />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  ForeignBoatIdDetail: state.data.ForeignBoatIdDetail,
  BoatStageList: state.data.BoatStageList,
  ForeignBoatNationList: state.data.ForeignBoatNationList,
});
const mapDispatchToProps = dispatch => ({
  clearKey: key => Actions.clearKey(dispatch, { key }),
  setPageText: text => Actions.setPageText(dispatch, { text }),
  getForeignBoatIdDetail: id => Actions_Wind.getForeignBoatIdDetail(dispatch, { id }),
  getBaseData: () => {
    Actions_Wind.getForeignBoatNationList(dispatch);
  },
  postAddNewForeignBoat: body => Actions_Wind.postAddNewForeignBoat(dispatch, { body }),
  putForeignBoatIdDetail: (id, body) => Actions_Wind.putForeignBoatIdDetail(dispatch, { id, body }),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddAndEdit);
